import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { OrangeTextButton } from "../../common/OrangeTextButton";
import { useNavigate } from "react-router-dom";
import { TextField } from "@mui/material";
import FormLabel from "@mui/material/FormLabel";
import { Autocomplete } from "@mui/material";
import { useEditCameraStore } from "./editCameraStore/editCameraStore";

export const AddSysaidAlertDialog = ({
  setCameraGeneralInfo,
  setCameraGeneralInfoBackup,
  setPatchObject,
  cameraGeneralInfoBackup,
}: {
  setCameraGeneralInfo: any;
  setCameraGeneralInfoBackup: any;
  setPatchObject: any;
  cameraGeneralInfoBackup: any;
}) => {
  const {
    cameraStreams,
    cameraStreamsPatchObject,
    cameraStreamsObject,
    addSysaidAlertDialogOpen,
    setAddSysaidAlertDialogOpen,
    handleSubmitNewSysaidAlert,
  } = useEditCameraStore();

  const streamNames = new Map();
  cameraStreams?.forEach((object: any, index: number) => {
    streamNames.set(`${object.name} (${object.product})`, index);
  });

  const navigate = useNavigate();

  const [postObject, setPostObject] = React.useState({
    id: -1,
    sysaid_server: "",
    sysaid_client_local: "",
    sysaid_username: "",
    sysaid_password: "",
  });

  const [selectedStreamNames, setSelectedStreamNames] = React.useState<
    string[]
  >([]);

  React.useEffect(() => {
    if (cameraStreamsObject[0]?.sysaid_alerts) {
      setPostObject({
        id: -1,
        sysaid_server: cameraStreamsObject[0]?.sysaid_alerts[0]?.sysaid_server,
        sysaid_client_local:
          cameraStreamsObject[0]?.sysaid_alerts[0]?.sysaid_client_local,
        sysaid_username:
          cameraStreamsObject[0]?.sysaid_alerts[0]?.sysaid_username,
        sysaid_password:
          cameraStreamsObject[0]?.sysaid_alerts[0]?.sysaid_password,
      });
    }
  }, []);

  return (
    <Dialog open={addSysaidAlertDialogOpen}>
      <DialogTitle id="alert-dialog-title">Add SysAid Alert</DialogTitle>
      <DialogContent>
        {cameraStreams && cameraStreams.length > 1 && (
          <div>
            <FormLabel component="legend" sx={{ paddingBottom: 1 }}>
              {" "}
              Streams*
            </FormLabel>
            <Autocomplete
              multiple
              options={cameraStreams.map((object: any) => {
                return `${object.name} (${object.product})`;
              })}
              sx={{ width: 400 }}
              renderInput={(params) => <TextField {...params} />}
              onChange={(event, value) => {
                setSelectedStreamNames(value);
              }}
            />
            <br></br>
          </div>
        )}
        <TextField
          id="sysaid_server"
          variant="standard"
          label="SysAid Server"
          defaultValue={postObject.sysaid_server}
          onChange={(event) => {
            setPostObject((previousState: any) => {
              return { ...previousState, sysaid_server: event.target.value };
            });
          }}
          sx={{ width: "400px" }}
          type="string"
        />
        <br></br>
        <br></br>
        <TextField
          id="sysaid_client_local"
          variant="standard"
          label="SysAid Client Local"
          defaultValue={postObject.sysaid_client_local}
          onChange={(event) => {
            setPostObject((previousState: any) => {
              return {
                ...previousState,
                sysaid_client_local: event.target.value,
              };
            });
          }}
          sx={{ width: "400px" }}
          type="string"
        />
        <br></br>
        <br></br>
        <TextField
          id="sysaid_username"
          variant="standard"
          label="SysAid Username"
          defaultValue={postObject.sysaid_username}
          onChange={(event) => {
            setPostObject((previousState: any) => {
              return { ...previousState, sysaid_username: event.target.value };
            });
          }}
          sx={{ width: "400px" }}
          type="string"
        />
        <br></br>
        <br></br>
        <TextField
          id="sysaid_password"
          variant="standard"
          label="SysAid Password"
          defaultValue={postObject.sysaid_password}
          onChange={(event) => {
            setPostObject((previousState: any) => {
              return { ...previousState, sysaid_password: event.target.value };
            });
          }}
          sx={{ width: "400px" }}
          type="string"
        />
      </DialogContent>
      <DialogActions>
        <OrangeTextButton
          onClick={() => {
            setAddSysaidAlertDialogOpen(false);
          }}
          text="Cancel"
          disabled={false}
        />
        <OrangeTextButton
          onClick={() => {
            const selectedStreamIndexs: number[] = [];

            const streamsObjectToPost = JSON.parse(
              JSON.stringify(cameraStreamsPatchObject)
            );

            if (cameraStreams && cameraStreams.length > 1) {
              selectedStreamNames.forEach((streamName: string) => {
                selectedStreamIndexs.push(streamNames.get(streamName));
              });

              selectedStreamIndexs.forEach((streamIndex: number) => {
                if (streamsObjectToPost[streamIndex]) {
                  streamsObjectToPost[streamIndex].sysaid_alerts = [
                    ...streamsObjectToPost[streamIndex].sysaid_alerts,
                    postObject,
                  ];
                }
              });
            }

            if (cameraStreams && cameraStreams.length === 1) {
              streamsObjectToPost[0].sysaid_alerts.push(postObject);
            }

            handleSubmitNewSysaidAlert(
              streamsObjectToPost,
              setCameraGeneralInfo,
              setCameraGeneralInfoBackup,
              setPatchObject,
              cameraGeneralInfoBackup,
              navigate
            );

            setAddSysaidAlertDialogOpen(false);
          }}
          text="Submit"
          disabled={false}
        />
      </DialogActions>
    </Dialog>
  );
};
